import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCirclearrows = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "current",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 5a7 7 0 0 0-5 2L5.7 5.7A9 9 0 0 1 21 12h2l-3 3-3-3h2a7 7 0 0 0-7-7Zm0 16c-5 0-9-4-9-9H1l3-3 3 3H5a7 7 0 0 0 12 5l1.4 1.4A9 9 0 0 1 12 21Z" })
});
export default SvgIconCirclearrows;
